import React, { useCallback } from 'react';
import TextField from '@material-ui/core/TextField';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

const SecretWithPatternComponent = (
  props: FieldExtensionComponentProps<string>,
) => {
  const { onChange, required, rawErrors, formData, schema, idSchema } = props;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  return (
    <TextField
      id={idSchema?.$id}
      label={schema.title || 'Secret'}
      helperText={(rawErrors?.length ? rawErrors.join(', ') : undefined) || schema.description}
      error={rawErrors != null && rawErrors.length > 0}
      required={required}
      value={formData ?? ''}
      onChange={handleChange}
      type="password"
      autoComplete="off"
      fullWidth
      variant="outlined"
      margin="dense"
    />
  );
};

const secretWithPatternValidation = (
  value: string,
  field: { addError: (message: string) => void },
  context: { schema: Record<string, unknown> },
) => {
  const pattern = context.schema?.pattern as string | undefined;
  if (pattern && value) {
    if (!new RegExp(pattern).test(value)) {
      field.addError('Invalid passcode');
    }
  }
};

export const SecretWithPatternFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SecretWithPattern',
    component: SecretWithPatternComponent,
    validation: secretWithPatternValidation,
  }),
);
